import React from 'react';

import { FormWrapper } from 'components/modules/Insurance/components/FormWrapper/FormWrapper';
import { NUMBER_MAX_99_MASK } from 'components/modules/Insurance/Insurance.constants';
import * as S from 'components/modules/Insurance/Insurance.styles';
import { FIELDS } from 'store/insuranceCalculation/constants';

import { useMultidriveFormPresenter } from './MultidriveForm.presenter';

export const MultidriveForm = () => {
  const presenter = useMultidriveFormPresenter();

  return (
    <FormWrapper>
      <S.TextInputMasked
        disabled={presenter.disabled}
        error={presenter.errors[FIELDS.MIN_DRIVERS_AGE]}
        label="Минимальный возраст"
        mask={NUMBER_MAX_99_MASK}
        name={FIELDS.MIN_DRIVERS_AGE}
        value={presenter.values[FIELDS.MIN_DRIVERS_AGE]}
        onChange={presenter.onChange}
      />
      <S.TextInputMasked
        disabled={presenter.disabled}
        error={presenter.errors[FIELDS.MIN_DRIVERS_EXPERIENCE]}
        label="Минимальный стаж"
        mask={NUMBER_MAX_99_MASK}
        name={FIELDS.MIN_DRIVERS_EXPERIENCE}
        value={presenter.values[FIELDS.MIN_DRIVERS_EXPERIENCE]}
        onChange={presenter.onChange}
      />
    </FormWrapper>
  );
};
